import "./index.css";
import "./App.css";
import "./fonts.css";
import { LanguageProvider } from "./context/language-context/LanguageContext";
import { LoaderProvider } from "./context/loader-context/LoaderContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import router from "./routes/routes";
import { MicroRoot } from "./layout/MicroRoot";

function App() {
  const queryClient = new QueryClient();

  return (
    <MicroRoot>
      <QueryClientProvider client={queryClient}>
        <LanguageProvider>
          <LoaderProvider>
            <RouterProvider router={router} />
            <Toaster
              position="top-center"
              toastOptions={{
                duration: 5000,
                style: {
                  background: "transparent",
                  boxShadow: "none",
                  padding: 0,
                },
              }}
            />
          </LoaderProvider>
        </LanguageProvider>
      </QueryClientProvider>
    </MicroRoot>
  );
}

export default App;
